<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title" v-if="role == 'admin' || isManager() || hasTimesheetDelegation()">View Timesheet</h3>
          <h3 class="page-title" v-else>My Timesheet</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Form -->
    <div>
      <div class="row align-items-center">
        <div class="col-md-2">Employee Name/ID</div>
        <div class="col-md-4 pl-md-0">
          <Select2
            v-model="userId"
            :options="employees"
            v-if="!isLoadData && role == 'admin'"
            required
            @change="getTimesheet"
          />
          <span v-else>{{ employees.length ? employees[0].text : this.loadingName }}</span>
        </div>
        
        <div class="col-md-2 ml-md-4">Department</div>
        <div class="col-md-3 pl-md-0">
          {{ department }}
        </div>
      </div>
      <div class="row align-items-center mt-2">
        <div class="col-md-2">Month</div>
        <div class="col-md-3 pl-md-0">
          <select v-if="!isLoadData" class="custom-select" v-model="month" @change="getTimesheet">
            <option v-for="month in months" :key="month" :value="month">
              {{ month }}
            </option>
          </select>

          <span v-if="isLoadData">{{ month }}</span>
        </div>

        <div class="col-md-1 pl-md-0">&nbsp;</div>
        
        <div class="col-md-2 ml-md-4">Year</div>
        <div class="col-md-3 pl-md-0">
          <select v-if="!isLoadData" class="custom-select" v-model="year" @change="getTimesheet">
            <option v-for="year in years" :key="year" :value="year">
              {{ year }}
            </option>
          </select>

          <span v-if="isLoadData">{{ year }}</span>
        </div>
      </div>
      <div class="row align-items-center mt-3">
        <div class="col-md-6">
            <div v-if="showSubmissionButton">
                <button class="btn btn-secondary" @click="save"><i class="fa fa-save"></i> Save as Draft</button>
                <button class="btn btn-primary" @click="submit"><i class="fa fa-play"></i> Submit</button>
            </div>

            <div v-if="role == 'admin' && isApproved">
                <button class="btn btn-secondary" @click="changeToDraft">Change To Draft</button>
            </div>
        </div>

        <div class="col-md-2 ml-md-4">Status</div>
        <div class="col-md-3 pl-md-0">
          {{ ( isRejected) ? statusRejectedText : status }}
        </div>
      </div>
      <div class="row mt-4" v-if="isNewLayout">
        <div class="col-md-12" v-html="newLayoutMessage"></div>
      </div>

        <!-- Table List -->
        <div :class="isNewLayout ? 'row mt-1' : 'row mt-4'">
            <div class="col-md-12">
                <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
                <table class="table table-timesheet custom-table mb-0" :class="{ edit: (mode == 'edit' || mode == 'change'), view: (mode == 'view') }">
                    <thead class="thead-light">
                    <tr id="t-first-row">
                        <th class="col-attendance-center fixed-column col-group">Date</th>
                        <th class="col-attendance-center fixed-column col-group">Day</th>
                        <th class="col-attendance-center fixed-column col-group" v-if="isNewLayout"><div style="width:89.4px">Calendar</div></th>
                        <th class="col-attendance-center fixed-column col-group" v-if="isNewLayout">Work Status</th>
                        <th class="col-attendance-center fixed-column col-group" v-if="isNewLayout">Public Holiday</th>
                        <th class="col-attendance-center fixed-column col-group" v-if="isNewLayout"><div style="width:65.2px">Shift Code</div></th>
                        <th class="col-attendance-center fixed-column col-group" v-if="isNewLayout"><div style="width:65px">Shift Timing</div></th>
                        <th class="col-attendance-center fixed-column col-group"><div style="width:35px">Leave Taken</div></th>
                        <th class="col-attendance-center fixed-column col-group" :style="isNewLayout ? '' : 'left: 230px'"><div style="width:40px">Off In Lieu Credit</div></th>
                        <th class="col-attendance-center fixed-column" v-if="isNewLayout">Imported OT Hours</th>
                        <th class="col-attendance-center fixed-column" v-if="isNewLayout">Approved OT Hours</th>
                        <th class="col-attendance-center fixed-column" v-if="isNewLayout && role == 'admin'"><div style="width:85px">OT 1.50</div>(Hourly Rate)</th>
                        <th class="col-attendance-center fixed-column" v-if="isNewLayout && role == 'admin'"><div style="width:85px">OT 2.00</div>(Hourly Rate)</th>
                        <th class="fixed-column table-nested" v-if="!isNewLayout">
                            <table class="table-inner hours" style="height: 110px" width="100%">
                                <tr>
                                    <th class="col-attendance-center fixed-column" colspan="2">Imported OT Hours</th>
                                </tr>
                                <tr>
                                    <th class="fixed-column number">Mon-Sat</th>
                                    <th class="fixed-column number">Sun& PH</th>
                                </tr>
                            </table>
                        </th>

                        <th class="fixed-column table-nested" v-if="!isNewLayout">
                            <table class="table-inner hours" style="height: 110px" width="100%">
                                <tr>
                                    <th class="col-attendance-center fixed-column" colspan="2">Approved OT Hours</th>
                                </tr>
                                <tr>
                                    <th class="fixed-column number">Mon-Sat</th>
                                    <th class="fixed-column number">Sun& PH</th>
                                </tr>
                            </table>
                        </th>

                        <th class="fixed-column table-nested">
                            <table class="table-inner hours" style="height: 110px" :class="{ overtime: mode=='edit' }" width="100%">
                                <tr>
                                    <th class="col-attendance-center fixed-column" colspan="2">Overtime<br>(24-hr format)</th>
                                </tr>
                                <tr>
                                    <th class="fixed-column number">Start Time</th>
                                    <th class="fixed-column number">End Time</th>
                                </tr>
                            </table>
                        </th>

                        <th class="col-attendance-center fixed-column">StandBy</th>

                        <th class="fixed-column table-nested">
                            <table class="table-inner shift" :class="{ shiftedit: mode=='edit', shifteditnew: isNewLayout }" width="100%">
                                <tr>
                                    <th class="col-attendance-center fixed-column table-shift" 
                                        :colspan="!isNewLayout ? 6 : 4" 
                                        v-html="!isNewLayout ? 'Shift<br>(24-hr format)' : 'Shift'"
                                        style="height:65px"
                                    >
                                    </th>
                                </tr>
                                <tr>
                                    <th class="fixed-column number table-shift" v-if="!isNewLayout">Start Time</th>
                                    <th class="fixed-column number table-shift" v-if="!isNewLayout">End Time</th>
                                    <th class="fixed-column number table-shift">12_hour Day</th>
                                    <th class="fixed-column number table-shift">12_hour Night</th>
                                    <th class="fixed-column number table-shift">8_hour Day</th>
                                    <th class="fixed-column number table-shift">8_hour Night</th>
                                </tr>
                            </table>
                        </th>

                        <th class="fixed-column table-nested">
                            <table class="table-inner clock" :class="{ clockedit: mode=='edit' }" width="100%">
                                <tr>
                                    <th class="col-attendance-center fixed-column" style="height:65px" colspan="3">Clock Timing<br>(24-hr format)</th>
                                </tr>
                                <tr>
                                    <th class="fixed-column number">Clock<br/>In</th>
                                    <th class="fixed-column number">Clock<br/>Out</th>
                                    <th class="fixed-column number">Clock<br/>Hours</th>
                                </tr>
                            </table>
                        </th>

                        <th class="fixed-column table-nested">
                            <table class="table-inner swingshift" width="100%">
                                <tr>
                                    <th class="col-attendance-center fixed-column table-shift" colspan="4" style="height:65px">Swing Shift Allowance</th>
                                </tr>
                                <tr>
                                    <th class="fixed-column number table-shift">Swing Shift -<br/>Day Allowance</th>
                                    <th class="fixed-column number table-shift">Swing Shift -<br/>Night Allowance</th>
                                    <th class="fixed-column number table-shift">Swing Shift -<br/>Saturday Allowance</th>
                                    <th class="fixed-column number table-shift">Swing Shift -<br/>Sunday Allowance</th>
                                </tr>
                            </table>
                        </th>

                        <th class="col-attendance-center fixed-column">Fab</th>
                        <th class="col-attendance-center fixed-column">Machine #</th>
                        <th class="col-attendance-center fixed-column">Service Order #</th>
                        <th class="col-attendance-center fixed-column">Purpose</th>
                    </tr>

                    <tr id="t-second-row">
                        <th class="fixed-column col-group">&nbsp;</th>
                        <th class="fixed-column col-group"><div style="min-width:30px">{{ !isNewLayout ? 'Total' : '&nbsp;' }}</div></th>
                        <th class="fixed-column col-group" style="top: 110px" v-if="isNewLayout">&nbsp;</th>
                        <th class="fixed-column col-group" style="top: 110px" v-if="isNewLayout">&nbsp;</th>
                        <th class="fixed-column col-group" style="top: 110px" v-if="isNewLayout">&nbsp;</th>
                        <th class="fixed-column col-group" style="top: 110px" v-if="isNewLayout">&nbsp;</th>
                        <th class="fixed-column col-group" style="top: 110px" v-if="isNewLayout">{{ isNewLayout ? 'Total' : '&nbsp;' }}</th>
                        <th class="fixed-column col-group" style="padding-left: 20px !important; top: 110px" v-html="totalLeaveTaken"></th>
                        <th class="fixed-column col-group" :style="'padding-left: 20px !important; top: 110px;' + (isNewLayout ? '' : 'left: 230px')" v-html="totalOilCredit"></th>
                        <th class="fixed-column" style="padding-left: 15px !important; top: 110px" v-html="totalImported" v-if="isNewLayout"></th>
                        <th class="fixed-column" style="padding-left: 15px !important; top: 110px" v-html="totalApproved" v-if="isNewLayout"></th>
                        <th class="fixed-column" style="padding-left: 15px !important; top: 110px" v-html="totalOT15" v-if="isNewLayout && role == 'admin'"></th>
                        <th class="fixed-column" style="padding-left: 15px !important; top: 110px" v-html="totalOT20" v-if="isNewLayout && role == 'admin'"></th>
                        <th class="fixed-column table-nested" style="top: 110px" v-if="!isNewLayout">
                            <table class="table-inner hours" width="100%">
                                <tr>
                                    <td v-html="totalImportedMonSat" class="fixed-column tlight total"></td>
                                    <td v-html="totalImportedSunPH" class="fixed-column tlight total"></td>
                                </tr>
                            </table>
                        </th>

                        <th class="fixed-column table-nested" style="top: 110px" v-if="!isNewLayout">
                            <table class="table-inner hours" width="100%">
                                <tr>
                                    <td v-html="totalApprovedMonSat" class="fixed-column tlight total"></td>
                                    <td v-html="totalApprovedSunPH" class="fixed-column tlight total"></td>
                                </tr>
                            </table>
                        </th>

                        <th class="fixed-column table-nested">
                            <table class="table-inner hours" :class="{ overtime: mode=='edit' }" width="100%">
                                <tr>
                                    <td class="fixed-column tlight total">&nbsp;</td>
                                    <td class="fixed-column tlight total">&nbsp;</td>
                                </tr>
                            </table>
                        </th>

                        <th class="fixed-column">
                            12-hr: <span v-html="standby12"></span>
                            <br>
                            24-hr: <span v-html="standby24"></span>
                        </th>

                        <th class="fixed-column table-nested">
                            <table class="table-inner shift" :class="{ shiftedit: mode=='edit', shifteditnew: isNewLayout }" width="100%">
                                <tr>
                                    <td class="fixed-column tlight total table-shift" v-if="!isNewLayout">&nbsp;</td>
                                    <td class="fixed-column tlight total table-shift" v-if="!isNewLayout">Total</td>
                                    <td v-html="Shift12HourDay" class="fixed-column tlight total table-shift"></td>
                                    <td v-html="Shift12HourNight" class="fixed-column tlight total table-shift"></td>
                                    <td v-html="Shift8HourDay" class="fixed-column tlight total table-shift"></td>
                                    <td v-html="Shift8HourNight" class="fixed-column tlight total table-shift"></td>
                                </tr>
                            </table>
                        </th>

                        <th class="fixed-column table-nested">
                            <table class="table-inner clock" :class="{ clockedit: mode=='edit' }" width="100%">
                                <tr>
                                    <td class="fixed-column tlight total">&nbsp;</td>
                                    <td class="fixed-column tlight total">&nbsp;</td>
                                    <td v-html="totalClockHours" class="fixed-column tlight total"></td>
                                </tr>
                            </table>
                        </th>

                        <th class="fixed-column table-nested">
                            <table class="table-inner swingshift" width="100%">
                                <tr>
                                    <td v-html="totalSwingShiftDayAllowance" class="fixed-column tlight total table-shift"></td>
                                    <td v-html="totalSwingShiftNightAllowance" class="fixed-column tlight total table-shift"></td>
                                    <td v-html="totalSwingShiftSaturdayAllowance" class="fixed-column tlight total table-shift"></td>
                                    <td v-html="totalSwingShiftSundayAllowance" class="fixed-column tlight total table-shift"></td>
                                </tr>
                            </table>
                        </th>

                        <th class="fixed-column">&nbsp;</th>
                        <th class="fixed-column">&nbsp;</th>
                        <th class="fixed-column">&nbsp;</th>
                        <th class="fixed-column">&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, i) in displayDates" :key="i">
                            <td class="col-group">
                                {{ item }}
                            </td>

                            <td class="col-group">
                                {{ days[i] }}
                            </td>

                            <td v-if="isNewLayout" class="col-group" v-html="timesheetDetails[i].calendarCode"></td>
                            <td v-if="isNewLayout" class="col-group" v-html="timesheetDetails[i].workStatus"></td>
                            <td v-if="isNewLayout" class="col-group">{{ timesheetDetails[i].ph ? 'Yes' : 'No' }}</td>
                            <td v-if="isNewLayout" class="col-group" v-html="timesheetDetails[i].shiftCode"></td>
                            <td v-if="isNewLayout" class="col-group">{{ !timesheetDetails[i].normalStartTime && !timesheetDetails[i].normalEndTime ? '' : timesheetDetails[i].normalStartTime + ' - ' + timesheetDetails[i].normalEndTime }}</td>
                            <td class="col-group" style="padding-left: 20px !important;">{{ timesheetDetails[i].leaveTaken }}</td>
                            <td class="col-group" :style="'padding-left: 20px !important;' + (isNewLayout ? '' : 'left: 230px')">{{ timesheetDetails[i].oilCredit }}</td>
                            <td style="padding: 0 !important;" v-if="isNewLayout">
                                <table class="table-inner hours table-inner-detail" width="100%">
                                    <tr>
                                        <td class="readonly" v-html="timesheetDetails[i].importedHours"></td>
                                    </tr>
                                </table>
                            </td>
                            <td style="padding: 0 !important;" v-if="isNewLayout">
                                <table class="table-inner hours table-inner-detail" width="100%">
                                    <tr v-if="mode == 'view'">
                                        <td class="view" :class="{ timesheethighlighted: (timesheetDetails[i].importedHours != timesheetDetails[i].approvedHours) }" v-html="timesheetDetails[i].approvedHours"></td>
                                    </tr>
                                    <tr v-if="mode == 'edit' || mode == 'change'">
                                        <td 
                                            v-if="(timesheetDetails[i].workStatus=='Work' && !timesheetDetails[i].ph && timesheetDetails[i].shiftCode.includes('12')) || timesheetDetails[i].oilCredit > 0" 
                                            class="readonly" 
                                            v-html="timesheetDetails[i].approvedHours">
                                        </td>
                                        <td class="edit" v-else>
                                            <input type="text" v-model="timesheetDetails[i].approvedHours" @keyup="calculateSwingShiftAllowance(i)" @change="checkOvertime(i)" class="form-control" />
                                        </td>
                                    </tr>
                                </table>
                            </td>
                            <td style="padding-left: 15px !important;" v-if="isNewLayout && role == 'admin'">{{ timesheetDetails[i].ot15 }}</td>
                            <td style="padding-left: 15px !important;" v-if="isNewLayout && role == 'admin'">{{ timesheetDetails[i].ot20 }}</td>
                            
                            <td style="padding: 0 !important;" v-if="!isNewLayout">
                                <table class="table-inner hours table-inner-detail" width="100%">
                                    <tr>
                                        <td class="readonly" v-html="timesheetDetails[i].importedHoursMonSat"></td>
                                        <td class="readonly" v-html="timesheetDetails[i].importedHoursSunPH"></td>
                                    </tr>
                                </table>
                            </td>

                            <td style="padding: 0 !important;" v-if="!isNewLayout">
                                <table class="table-inner hours table-inner-detail" width="100%">
                                    <tr v-if="mode == 'view'">
                                        <td class="view" :class="{ timesheethighlighted: (timesheetDetails[i].importedHoursMonSat != timesheetDetails[i].approvedHoursMonSat) }" v-html="timesheetDetails[i].approvedHoursMonSat"></td>
                                        <td class="view" :class="{ timesheethighlighted: (timesheetDetails[i].importedHoursSunPH != timesheetDetails[i].approvedHoursSunPH) }" v-html="timesheetDetails[i].approvedHoursSunPH"></td>
                                    </tr>

                                    <tr v-if="mode == 'edit' || mode == 'change'">
                                        <td class="edit">
                                            <input type="text" v-model="timesheetDetails[i].approvedHoursMonSat" @keyup="calculateTotal" @change="checkOvertime(i)" class="form-control" />
                                        </td>
                                        <td class="edit">
                                            <input type="text" v-model="timesheetDetails[i].approvedHoursSunPH" @keyup="calculateTotal" @change="checkOvertime(i)" class="form-control" />
                                        </td>
                                    </tr>
                                </table>
                            </td>

                            <td style="padding: 0 !important;">
                                <table v-if="mode == 'view'" class="table-inner hours table-inner-detail" width="100%">
                                    <tr>
                                        <td class="view" v-html="timesheetDetails[i].overtimeStartTime.length == 0 ? '&nbsp;' : timesheetDetails[i].overtimeStartTime"></td>
                                        <td class="view" v-html="timesheetDetails[i].overtimeEndTime.length == 0 ? '&nbsp;' : timesheetDetails[i].overtimeEndTime"></td>
                                    </tr>
                                </table>

                                <table v-if="mode == 'edit' || mode == 'change'" class="table-inner overtime hours table-inner-detail" width="100%">
                                    <tr>
                                        <template v-if="(timesheetDetails[i].workStatus=='Work' && !timesheetDetails[i].ph && timesheetDetails[i].shiftCode.includes('12')) || timesheetDetails[i].oilCredit > 0">
                                            <td class="readonly" v-html="timesheetDetails[i].overtimeStartTime || '&nbsp;'"></td>
                                            <td class="readonly" v-html="timesheetDetails[i].overtimeEndTime || '&nbsp;'"></td>
                                        </template>
                                        <template v-else>
                                            <td class="edit">
                                                <select class="custom-select attendance" v-model="timesheetDetails[i].overtimeStartTime" @change="checkOvertime(i);calculateSwingShiftAllowance(i)">
                                                    <option value=""></option>
                                                    <option v-for="time in availableTimes" :key="time" :value="time">
                                                    {{ time }}
                                                    </option>
                                                </select>
                                            </td>
                                            <td class="edit">
                                                <select class="custom-select attendance" v-model="timesheetDetails[i].overtimeEndTime" @change="checkOvertime(i);calculateSwingShiftAllowance(i)">
                                                    <option value=""></option>
                                                    <option v-for="time in availableTimes" :key="time" :value="time">
                                                    {{ time }}
                                                    </option>
                                                </select>
                                            </td>
                                        </template>
                                    </tr>
                                </table>
                            </td>

                            <td v-if="mode == 'view'" v-html="timesheetDetails[i].standby.length == 0 ? '&nbsp;' : timesheetDetails[i].standby">
                            </td>

                            <td v-if="mode == 'edit' || mode == 'change'" class="edit">
                                <select class="custom-select attendance" :class="{ standbyedit: (mode == 'edit' || mode == 'change') }" v-model="timesheetDetails[i].standby" @change="calculateTotal">
                                    <option value=""></option>
                                    <option v-for="standby in availableStandBy" :key="standby" :value="standby">
                                    {{ standby }}
                                    </option>
                                </select>
                            </td>

                            <td style="padding: 0 !important;">
                                <table v-if="mode == 'view'" :class="'table-inner shift hours table-inner-detail ' + (isNewLayout ? 'shifteditnew' : '')" width="100%">
                                    <tr>
                                        <td v-if="!isNewLayout" class="view" v-html="timesheetDetails[i].shiftStartTime.length == 0 ? '&nbsp;' : timesheetDetails[i].shiftStartTime"></td>
                                        <td v-if="!isNewLayout" class="view" v-html="timesheetDetails[i].shiftEndTime.length == 0 ? '&nbsp;' : timesheetDetails[i].shiftEndTime"></td>

                                        <td class="readonly" v-html="timesheetDetails[i].Shift12HourDay"></td>
                                        <td class="readonly" v-html="timesheetDetails[i].Shift12HourNight"></td>
                                        <td class="readonly" v-html="timesheetDetails[i].Shift8HourDay"></td>
                                        <td class="readonly" v-html="timesheetDetails[i].Shift8HourNight"></td>
                                    </tr>
                                </table>

                                <table v-if="mode == 'edit' || mode == 'change'" :class="'table-inner shift ' + (isNewLayout ? 'shifteditnew' : 'shiftedit') + ' hours table-inner-detail'" width="100%">
                                    <tr>
                                        <td class="edit" v-if="!isNewLayout">
                                            <select class="custom-select attendance" @change="checkShiftTime(i)" v-model="timesheetDetails[i].shiftStartTime">
                                                <option value=""></option>
                                                <option v-for="time in availableTimes" :key="time" :value="time">
                                                {{ time }}
                                                </option>
                                            </select>
                                        </td>
                                        <td class="edit" v-if="!isNewLayout">
                                            <select class="custom-select attendance" @change="checkShiftTime(i)" v-model="timesheetDetails[i].shiftEndTime">
                                                <option value=""></option>
                                                <option v-for="time in availableTimes" :key="time" :value="time">
                                                {{ time }}
                                                </option>
                                            </select>
                                        </td>

                                        <td class="readonly" v-html="timesheetDetails[i].Shift12HourDay"></td>
                                        <td class="readonly" v-html="timesheetDetails[i].Shift12HourNight"></td>
                                        <td class="readonly" v-html="timesheetDetails[i].Shift8HourDay"></td>
                                        <td class="readonly" v-html="timesheetDetails[i].Shift8HourNight"></td>
                                    </tr>
                                </table>
                            </td>

                            <td style="padding: 0 !important;">
                                <table v-if="mode == 'view'" class="table-inner clock table-inner-detail" width="100%">
                                    <tr>
                                        <td class="view" v-html="timesheetDetails[i].clockIn.length == 0 ? '&nbsp;' : timesheetDetails[i].clockIn"></td>
                                        <td class="view" v-html="timesheetDetails[i].clockOut.length == 0 ? '&nbsp;' : timesheetDetails[i].clockOut"></td>
                                        <td class="view" v-html="timesheetDetails[i].clockHours ? timesheetDetails[i].clockHours : 0"></td>
                                    </tr>
                                </table>

                                <table v-if="mode == 'edit' || mode == 'change'" class="table-inner clockedit table-inner-detail" width="100%">
                                    <tr>
                                        <template v-if="timesheetDetails[i].calendarCode.includes('SS') && timesheetDetails[i].oilCredit>0">
                                            <td class="edit">
                                                <select class="custom-select attendance" v-model="timesheetDetails[i].clockIn" @change="checkClockHours(i);calculateSwingShiftAllowance(i)">
                                                    <option value=""></option>
                                                    <option v-for="time in availableTimes" :key="time" :value="time">
                                                    {{ time }}
                                                    </option>
                                                </select>
                                            </td>
                                            <td class="edit">
                                                <select class="custom-select attendance" v-model="timesheetDetails[i].clockOut" @change="checkClockHours(i);calculateSwingShiftAllowance(i)">
                                                    <option value=""></option>
                                                    <option v-for="time in availableTimes" :key="time" :value="time">
                                                    {{ time }}
                                                    </option>
                                                </select>
                                            </td>
                                        </template>
                                        <template v-else>
                                            <td class="readonly" v-html="timesheetDetails[i].clockIn || '&nbsp;'"></td>
                                            <td class="readonly" v-html="timesheetDetails[i].clockOut || '&nbsp;'"></td>
                                        </template>
                                        <td class="readonly" v-html="timesheetDetails[i].clockHours == null ? '&nbsp;' : timesheetDetails[i].clockHours"></td>
                                    </tr>
                                </table>
                            </td>

                            <td style="padding: 0 !important;">
                                <table class="table-inner table-inner-detail swingshift" width="100%">
                                    <tr>
                                        <td class="readonly" v-html="timesheetDetails[i].swingShiftDayAllowance"></td>
                                        <td class="readonly" v-html="timesheetDetails[i].swingShiftNightAllowance"></td>
                                        <td class="readonly" v-html="timesheetDetails[i].swingShiftSaturdayAllowance"></td>
                                        <td class="readonly" v-html="timesheetDetails[i].swingShiftSundayAllowance"></td>
                                    </tr>
                                </table>
                            </td>

                            <td class="text-fab" v-if="mode == 'view'" v-html="timesheetDetails[i].fab.length == 0 ? '&nbsp;' : timesheetDetails[i].fab">
                            </td>

                            <td v-if="mode == 'edit' || mode == 'change'" class="edit">
                                <input type="text" v-model="timesheetDetails[i].fab" class="form-control text-fab" />
                            </td>

                            <td class="text-machine" v-if="mode == 'view'" v-html="timesheetDetails[i].machine.length == 0 ? '&nbsp;' : timesheetDetails[i].machine">
                            </td>

                            <td v-if="mode == 'edit' || mode == 'change'" class="edit">
                                <input type="text" v-model="timesheetDetails[i].machine" class="form-control text-machine" />
                            </td>

                            <td class="text-service-order" v-if="mode == 'view'" v-html="timesheetDetails[i].serviceOrder.length == 0 ? '&nbsp;' : timesheetDetails[i].serviceOrder">
                            </td>

                            <td v-if="mode == 'edit' || mode == 'change'" class="edit">
                                <input type="text" v-model="timesheetDetails[i].serviceOrder" class="form-control text-service-order" />
                            </td>

                            <td class="text-purpose" v-if="mode == 'view'" v-html="timesheetDetails[i].purpose.length == 0 ? '&nbsp;' : timesheetDetails[i].purpose">
                            </td>

                            <td v-if="mode == 'edit' || mode == 'change'" class="edit">
                                <textarea rows="3" v-model="timesheetDetails[i].purpose" class="form-control text-purpose" />
                            </td>
                        </tr>
                    </tbody>
                </table>
                </div>
            </div>
        </div>
        <!-- /Table List -->

        <!-- Attachment -->
        <div class="mt-3">
            <strong>Attach file(s):</strong><br>
            <template v-if="status == 'BLANK' || status == 'NEW' || status == 'DRAFT' || (status  == 'REJECTED' && (!isManager() || (isManager() && tokenObj.Id == userId)))">
                <p v-if="attachment1 == null || attachment1 == ''">
                    <input type="file" v-on:change="setAttachment($event)" ref="fileupload1" accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx" :data-index="1" />
                    <i v-if="newAttachment1 != null && newAttachment1 != ''" class="fa fa-minus-circle" @click="resetAttachment(1)"></i>
                </p>
                <p v-else>
                    Attachment 1: 
                    <a target="_blank" v-if="attachmentURL1 != '' && attachmentURL1 != null" :href="attachmentURL1">{{ attachmentFilename1 }}</a>
                    <span v-else>{{ attachmentFilename1 }}</span>
                    <i class="fa fa-minus-circle" @click="resetAttachment(1)"></i>
                </p>

                <p v-if="attachment2 == null || attachment2 == ''">
                    <input type="file" v-on:change="setAttachment($event)" ref="fileupload2" accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx" :data-index="2" />
                    <i v-if="newAttachment2 != null && newAttachment2 != ''" class="fa fa-minus-circle" @click="resetAttachment(2)"></i>
                </p>
                <p v-else>
                    Attachment 2:
                    <a target="_blank" v-if="attachmentURL2 != '' && attachmentURL2 != null" :href="attachmentURL2">{{ attachmentFilename2 }}</a>
                    <span v-else>{{ attachmentFilename2 }}</span>
                    <i class="fa fa-minus-circle" @click="resetAttachment(2)"></i>
                </p>

                <p v-if="attachment3 == null || attachment3 == ''">
                    <input type="file" v-on:change="setAttachment($event)" ref="fileupload3" accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx" :data-index="3" />
                    <i v-if="newAttachment3 != null && newAttachment3 != ''" class="fa fa-minus-circle" @click="resetAttachment(3)"></i>
                </p>
                <p v-else>
                    Attachment 3:
                    <a target="_blank" v-if="attachmentURL3 != '' && attachmentURL3 != null" :href="attachmentURL3">{{ attachmentFilename3 }}</a>
                    <span v-else>{{ attachmentFilename3 }}</span>
                    <i class="fa fa-minus-circle" @click="resetAttachment(3)"></i>
                </p>

                <p v-if="attachment4 == null || attachment4 == ''">
                    <input type="file" v-on:change="setAttachment($event)" ref="fileupload4" accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx" :data-index="4" />
                    <i v-if="newAttachment4 != null && newAttachment4 != ''" class="fa fa-minus-circle" @click="resetAttachment(4)"></i>
                </p>
                <p v-else>
                    Attachment 4:
                    <a target="_blank" v-if="attachmentURL4 != '' && attachmentURL4 != null" :href="attachmentURL4">{{ attachmentFilename4 }}</a>
                    <span v-else>{{ attachmentFilename4 }}</span>
                    <i class="fa fa-minus-circle" @click="resetAttachment(4)"></i>
                </p>

                <p v-if="attachment5 == null || attachment5 == ''">
                    <input type="file" v-on:change="setAttachment($event)" ref="fileupload5" accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx" :data-index="5" />
                    <i v-if="newAttachment5 != null && newAttachment5 != ''" class="fa fa-minus-circle" @click="resetAttachment(5)"></i>
                </p>
                <p v-else>
                    Attachment 5:
                    <a target="_blank" v-if="attachmentURL5 != '' && attachmentURL5 != null" :href="attachmentURL5">{{ attachmentFilename5 }}</a>
                    <span v-else>{{ attachmentFilename5 }}</span>
                    <i class="fa fa-minus-circle" @click="resetAttachment(5)"></i>
                </p>

                <p>
                    Allowed file extension(s): jpg, jpeg, png, pdf, doc, docx, xls, xlsx
                    <br>
                    Maximum file size per attachment: {{ maxUploadFileSize }}MB
                </p>
            </template>
            <template v-else>
                <p>
                    Attachment 1: 
                    <a target="_blank" v-if="attachmentURL1 != '' && attachmentURL1 != null" :href="attachmentURL1">{{ attachmentFilename1 }}</a>
                    <span v-else>No File</span>
                </p>

                <p>
                    Attachment 2: 
                    <a target="_blank" v-if="attachmentURL2 != '' && attachmentURL2 != null" :href="attachmentURL2">{{ attachmentFilename2 }}</a>
                    <span v-else>No File</span>
                </p>

                <p>
                    Attachment 3: 
                    <a target="_blank" v-if="attachmentURL3 != '' && attachmentURL3 != null" :href="attachmentURL3">{{ attachmentFilename3 }}</a>
                    <span v-else>No File</span>
                </p>

                <p>
                    Attachment 4: 
                    <a target="_blank" v-if="attachmentURL4 != '' && attachmentURL4 != null" :href="attachmentURL4">{{ attachmentFilename4 }}</a>
                    <span v-else>No File</span>
                </p>

                <p>
                    Attachment 5: 
                    <a target="_blank" v-if="attachmentURL5 != '' && attachmentURL5 != null" :href="attachmentURL5">{{ attachmentFilename5 }}</a>
                    <span v-else>No File</span>
                </p>
            </template>
        </div>
        <!-- /Attachment -->

        <div class="mt-3" v-if="mode == 'change'">
            <strong>Indicate in the field below reason/s for changes:</strong><br>
            <textarea class="form-control" v-model="remarks" rows="3" required></textarea>
            <div class="mt-2 text-center">
                <button class="btn btn-primary" @click="saveChanges">Save</button>
                <button class="btn btn-secondary" @click="changeMode('view')">Cancel</button>
            </div>
        </div>

        <div class="mt-3" v-if="status == 'REJECTED'">
            <strong>Manager's Remarks</strong><br>
            <textarea class="form-control" v-model="remarks" rows="3" readonly></textarea>
        </div>

        <div class="mt-3" v-if="mode != 'change' && status == 'PENDING' && ((isManager() && tokenObj.Id != userId) || hasTimesheetDelegation())">
            <strong>Remarks is mandatory if you are rejecting or changing this timesheet.</strong><br>
            <textarea class="form-control" v-model="remarks" rows="3" required></textarea>
            <div class="mt-2 text-center">
                <button class="btn btn-primary" @click="approve">Approved</button>
                <button class="btn btn-primary" @click="reject">Rejected</button>
                <button class="btn btn-primary" @click="changeMode('change')">Change</button>
                <button class="btn btn-secondary" @click="back"><i class="fa fa-chevron-left"></i> Back</button>
            </div>
        </div>

        <div class="mt-3" v-else-if="isLoadData">
            <button class="btn btn-secondary" @click="back"><i class="fa fa-chevron-left"></i> Back</button>
        </div>

        <div class="row align-items-center mt-3">
            <div class="col-md-6">
                <div v-if="showSubmissionButton">
                    <button class="btn btn-secondary" @click="save"><i class="fa fa-save"></i> Save as Draft</button>
                    <button class="btn btn-primary" @click="submit"><i class="fa fa-play"></i> Submit</button>
                </div>
            </div>
        </div>
    </div>
    <!-- /Form -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
import Select2 from "v-select2-component";
export default {
  data() {
    return {
      isNewLayout: false,
      newLayoutMessage: "",
      defaultNewLayoutMessage: "No overtime for 12N and 12D on regular working day",
      benefitOptionItemMapping: [],
      isEdit: false,
      totalLeaveTaken: 0,
      totalOilCredit: 0,
      totalImportedMonSat: 0,
      totalImportedSunPH: 0,
      totalImported: 0,
      totalApprovedMonSat: 0,
      totalApprovedSunPH: 0,
      totalApproved: 0,
      totalOT15: 0,
      totalOT20: 0,
      standby12: 0,
      standby24: 0,
      Shift12HourDay: 0,
      Shift12HourNight: 0,
      Shift8HourDay: 0,
      Shift8HourNight: 0,
      totalClockHours: 0,
      totalSwingShiftDayAllowance: 0,
      totalSwingShiftNightAllowance: 0,
      totalSwingShiftSaturdayAllowance: 0,
      totalSwingShiftSundayAllowance: 0,
      userId: "",
      dates: [],
      submitDates: [],
      days: [],
      employees: [],
      years: [],
      months: [],
      loadingName: config.LOADING_EMPLOYEE_NAME,
      month: "",
      currentMonth: 0,
      year: "",
      department: "",
      status: config.LOADING_EMPLOYEE_NAME,
      statusRejectedText: "",
      timesheetID: "",
      timesheetDetails: [],
      mode: "view",
      availableTimes: [],
      availableStandBy: ["1200", "2400"],
      showSubmissionButton: false,
      remarks: "",
      isLoadData: false,
      isApproved: false,
      isRejected: false,
      attachment1: null,
      attachment2: null,
      attachment3: null,
      attachment4: null,
      attachment5: null,
      newAttachment1: null,
      newAttachment2: null,
      newAttachment3: null,
      newAttachment4: null,
      newAttachment5: null,
      attachmentFilename1: '',
      attachmentFilename2: '',
      attachmentFilename3: '',
      attachmentFilename4: '',
      attachmentFilename5: '',
      newAttachmentFilename1: '',
      newAttachmentFilename2: '',
      newAttachmentFilename3: '',
      newAttachmentFilename4: '',
      newAttachmentFilename5: '',
      attachmentURL1: '',
      attachmentURL2: '',
      attachmentURL3: '',
      attachmentURL4: '',
      attachmentURL5: '',
      maxUploadFileSize: config.UPLOAD_FILE_LIMIT_MB,
      deletedAttachment: new Array(),
      displayDates: [],
      maxHours: 72,
      maxHoursMessage: 'Maximum Total Allowed Approved OT Hours for submission is 72.',
      maxHoursPerDayShift8: 4,
      maxHoursPerDayShift8Message: 'Maximum Allowed Approved OT Hours for submission is 4',
      maxHoursPerDay: 12,
      maxHoursPerDayMessage: 'Maximum Allowed Approved OT Hours for submission is 12'
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
    tokenObj() {
        let data = JSON.parse(localStorage.getItem("lambitoken"));
        return data;
    },
  },

  methods: {
    isManager() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.IsManager ? data.IsManager : false;
    },
    hasTimesheetDelegation() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.HasTimesheetDelegation ? data.HasTimesheetDelegation : false;
    },
    back() {
        // this.$router.push('/attendance/list/timesheet');
        this.$router.go(-1);
    },
    resetAttachment(index){
        switch(index) {
            case 1:
                this.newAttachment1 = null;
                this.attachment1 = null;
                this.attachmentFilename1 = "";
                this.newAttachmentFilename1 = "";
                this.deletedAttachment.push('1');
                break;
            case 2:
                this.newAttachment2 = null;
                this.attachment2 = null;
                this.attachmentFilename2 = "";
                this.newAttachmentFilename2 = "";
                this.deletedAttachment.push('2');
                break;
            case 3:
                this.newAttachment3 = null;
                this.attachment3 = null;
                this.attachmentFilename3 = "";
                this.newAttachmentFilename3 = "";
                this.deletedAttachment.push('3');
                break;
            case 4:
                this.newAttachment4 = null;
                this.attachment4 = null;
                this.attachmentFilename4 = "";
                this.newAttachmentFilename4 = "";
                this.deletedAttachment.push('4');
                break;
            case 5:
                this.newAttachment5 = null;
                this.attachment5 = null;
                this.attachmentFilename5 = "";
                this.newAttachmentFilename5 = "";
                this.deletedAttachment.push('5');
                break;
        }
    },
    setAttachment(event) {
        let index = event.target.dataset.index;

        var fileSizeInMB = event.target.files[0].size / 1024 / 1024;
        // console.log ( fileSizeInMB + " " + config.UPLOAD_FILE_LIMIT_MB );
        if ( fileSizeInMB < config.UPLOAD_FILE_LIMIT_MB ) {
            const reader = new FileReader();
            reader.readAsDataURL(event.target.files[0]);
            reader.onload = (evt) => {
                switch(index) {
                    case '1':
                        this.newAttachment1 = evt.target.result;
                        this.attachment1 = evt.target.result;
                        this.attachmentFilename1 = event.target.files[0].name;
                        this.newAttachmentFilename1 = event.target.files[0].name;
                        break;
                    case '2':
                        this.newAttachment2 = evt.target.result;
                        this.attachment2 = evt.target.result;
                        this.attachmentFilename2 = event.target.files[0].name;
                        this.newAttachmentFilename2 = event.target.files[0].name;
                        break;
                    case '3':
                        this.newAttachment3 = evt.target.result;
                        this.attachment3 = evt.target.result;
                        this.attachmentFilename3 = event.target.files[0].name;
                        this.newAttachmentFilename3 = event.target.files[0].name;
                        break;
                    case '4':
                        this.newAttachment4 = evt.target.result;
                        this.attachment4 = evt.target.result;
                        this.attachmentFilename4 = event.target.files[0].name;
                        this.newAttachmentFilename4 = event.target.files[0].name;
                        break;
                    case '5':
                        this.newAttachment5 = evt.target.result;
                        this.attachment5 = evt.target.result;
                        this.attachmentFilename5 = event.target.files[0].name;
                        this.newAttachmentFilename5 = event.target.files[0].name;
                        break;
                }

                for ( let loop = 0; loop < this.deletedAttachment.length; loop++ ) {
                    if ( this.deletedAttachment[loop] == index ) {
                        this.deletedAttachment.splice(loop, 1);
                    }
                }

                // console.log(this.newAttachment1);
            }
        }
        else {
            this.$swal('Attachment file size cannot be more than ' + config.UPLOAD_FILE_LIMIT_MB + ' MB', { icon: "error" });
            
            switch(index) {
                case '1':
                    this.$refs.fileupload1.value=null;
                    break;
                case '2':
                    this.$refs.fileupload2.value=null;
                    break;
                case '3':
                    this.$refs.fileupload3.value=null;
                    break;
                case '4':
                    this.$refs.fileupload4.value=null;
                    break;
                case '5':
                    this.$refs.fileupload5.value=null;
                    break;
            }
        }
    },
    generateDatesAndDays() {
        // console.log("Generate Dates and Days");
        const date = new Date();

        let currentMonth = parseInt(this.currentMonth) + 1;
        let numberOfDays = new Date(
            this.year,
            currentMonth,
            0
        ).getDate();

        // console.log("Number of Days");
        // console.log(currentMonth + " " + numberOfDays);

        this.dates = [];
        this.displayDates = [];
        this.days = [];
        let dateShortName;
        for ( let index = 0; index < numberOfDays; index++ ) {
            this.displayDates.push( ((index + 1) > 9 ? (index + 1) : ("0" + (index + 1))) + "/" + (currentMonth > 9 ? currentMonth : ("0" + currentMonth)) + "/" + this.year);
            // this.dates.push(date.getFullYear() + "-" + currentMonth + "-" + (index+1));
            this.dates.push(this.year + "-" + currentMonth + "-" + (index+1));

            //dateShortName = new Date(date.getFullYear(), currentMonth - 1, index + 1);
            dateShortName = new Date(this.year, currentMonth - 1, index + 1);
            // console.log(dateShortName.toLocaleString());
            this.days.push(dateShortName.toLocaleString('en-us', {weekday: 'short'}));
        }
        // console.log("End Generate Dates and Days");
    },
    getEmployees() {
      let param = { Token: this.token };
      this.$store.state.isLoading = true;
      API.getEmployees(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.employees = response.data.record;

            if ( this.role != 'admin' ) {
                this.userId = this.employees.length ? this.employees[0].id : "";
                this.department = this.employees.length ? this.employees[0].Department : "";
                this.getTimesheet();
            }
          } else {
            this.$swal(response.data.Message, { icon: "error" });
          }
        })
        .catch((error) => {
            console.log(error);
            this.$store.state.isLoading = false;
            this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    loadTimesheet(timesheetID) {
        let param = {
            Token: this.token,
            Id: timesheetID
        };

        for ( let index in this.employees ) {
            if ( this.employees[index].id == this.userId ) {
                this.department = this.employees[index].department;
            }
        }

        API.loadTimesheet(param)
        .then((response) => {
            this.$store.state.isLoading = false;
            if (response.data.success) {
                if ( response.data.isEmpty ) {
                    this.status = config.TIMESHEET_STATUS_BLANK;
                }
                else {
                    this.isNewLayout = response.data.isNewLayout;
                    this.newLayoutMessage = response.data.newLayoutMessage 
                                            ? response.data.newLayoutMessage.replace("\n","<br>")
                                            : this.defaultNewLayoutMessage;
                    var record = response.data.record;

                    this.employees.push( { department: response.data.employee.department, text: response.data.employee.text } );
                    this.department = response.data.employee.department;

                    this.timesheetID = timesheetID;
                    this.userId = response.data.employee.id;
                    this.status = response.data.record.Status;
                    this.remarks = response.data.record.Remarks;
                    this.month = response.data.record.Month;
                    this.year = response.data.record.Year;

                    this.attachment1 = record.Attachment1;
                    this.attachment2 = record.Attachment2;
                    this.attachment3 = record.Attachment3;
                    this.attachment4 = record.Attachment4;
                    this.attachment5 = record.Attachment5;

                    this.attachmentFilename1 = record.AttachmentFilename1;
                    this.attachmentFilename2 = record.AttachmentFilename2;
                    this.attachmentFilename3 = record.AttachmentFilename3;
                    this.attachmentFilename4 = record.AttachmentFilename4;
                    this.attachmentFilename5 = record.AttachmentFilename5;

                    this.attachmentURL1 = record.AttachmentURL1;
                    this.attachmentURL2 = record.AttachmentURL2;
                    this.attachmentURL3 = record.AttachmentURL3;
                    this.attachmentURL4 = record.AttachmentURL4;
                    this.attachmentURL5 = record.AttachmentURL5;

                    if ( this.status == config.TIMESHEET_STATUS_APPROVED ) {
                        this.status += response.data.record.ApprovedText;
                        this.isApproved = true;
                    }
                    else {
                        this.isApproved = false;
                    }

                    this.isLoadData = true;

                    for ( let index in response.data.record.TimesheetDetails ) {
                        let timesheetDetail = response.data.record.TimesheetDetails[index];

                        // console.log(timesheetDetail);

                        this.timesheetDetails[index] = {
                            date: timesheetDetail.Date,
                            calendarCode: timesheetDetail.CalendarCode,
                            workStatus: timesheetDetail.WorkStatus,
                            ph: timesheetDetail.IsPublicHoliday,
                            phLeave: timesheetDetail.IsPublicHolidayLeave,
                            shiftCode: timesheetDetail.ShiftCode,
                            normalStartTime: timesheetDetail.NormalStartTime,
                            normalEndTime: timesheetDetail.NormalEndTime,
                            leaveTaken: timesheetDetail.LeaveTaken ? timesheetDetail.LeaveTaken : 0,
                            oilCredit: timesheetDetail.OilCredit ? timesheetDetail.OilCredit : 0,
                            importedHours: timesheetDetail.ImportedHours ? timesheetDetail.ImportedHours : 0,
                            approvedHours: timesheetDetail.ApprovedHours ? timesheetDetail.ApprovedHours : 0,
                            ot15: timesheetDetail.Ot15 ? timesheetDetail.Ot15 : 0,
                            ot20: timesheetDetail.Ot20 ? timesheetDetail.Ot20 : 0,
                            importedHoursMonSat: timesheetDetail.ImportedHoursMonSat ? timesheetDetail.ImportedHoursMonSat :0,
                            importedHoursSunPH: timesheetDetail.ImportedHoursSunPH ? timesheetDetail.ImportedHoursSunPH : 0,
                            approvedHoursMonSat: timesheetDetail.ApprovedHoursMonSat ? timesheetDetail.ApprovedHoursMonSat : 0,
                            approvedHoursSunPH: timesheetDetail.ApprovedHoursSunPH ? timesheetDetail.ApprovedHoursSunPH : 0, 
                            overtimeStartTime: timesheetDetail.OvertimeStartTime ? timesheetDetail.OvertimeStartTime : "", 
                            overtimeEndTime: timesheetDetail.OvertimeEndTime ? timesheetDetail.OvertimeEndTime : "", 
                            standby: timesheetDetail.Standby, 
                            shiftStartTime: timesheetDetail.ShiftStartTime, 
                            shiftEndTime: timesheetDetail.ShiftEndTime,
                            Shift12HourDay: timesheetDetail.Shift12HourDay ? timesheetDetail.Shift12HourDay : 0, 
                            Shift12HourNight: timesheetDetail.Shift12HourNight ? timesheetDetail.Shift12HourNight : 0, 
                            Shift8HourDay: timesheetDetail.Shift8HourDay ? timesheetDetail.Shift8HourDay : 0, 
                            Shift8HourNight: timesheetDetail.Shift8HourNight ? timesheetDetail.Shift8HourNight : 0, 
                            clockIn: timesheetDetail.ClockIn ? timesheetDetail.ClockIn : "", 
                            clockOut: timesheetDetail.ClockOut ? timesheetDetail.ClockOut : "",
                            clockHours: timesheetDetail.ClockHours ? timesheetDetail.ClockHours : 0,
                            swingShiftDayAllowance: timesheetDetail.SwingShiftDayAllowance ? timesheetDetail.SwingShiftDayAllowance : 0,
                            swingShiftNightAllowance: timesheetDetail.SwingShiftNightAllowance ? timesheetDetail.SwingShiftNightAllowance : 0,
                            swingShiftSaturdayAllowance: timesheetDetail.SwingShiftSaturdayAllowance ? timesheetDetail.SwingShiftSaturdayAllowance : 0,
                            swingShiftSundayAllowance: timesheetDetail.SwingShiftSundayAllowance ? timesheetDetail.SwingShiftSundayAllowance : 0,
                            fab: timesheetDetail.Fab ? timesheetDetail.Fab : "", 
                            machine: timesheetDetail.Machine ? timesheetDetail.Machine : "", 
                            serviceOrder: timesheetDetail.ServiceOrder ? timesheetDetail.ServiceOrder : "", 
                            purpose: timesheetDetail.Purpose ? timesheetDetail.Purpose : ""
                        };
                    }

                    // set new month if it changes
                    for ( let index in this.months ) {
                        if ( this.months[index] == this.month ) {
                            this.currentMonth = index;
                        }
                    }

                    this.generateDatesAndDays();
                    this.calculateTotal();
                }
            } else {
                this.$swal(response.data.Message, { icon: "error" });
            }

            this.showSubmissionButton = false;

            this.calculateTotal();
        })
        .catch((error) => {
            this.$store.state.isLoading = false;
            this.$swal(error.response.data.Message, { icon: "error" });
        });   
    },
    getTimesheet() {
        this.timesheetDetails = [];

        // set new month if it changes
        for ( let index in this.months ) {
            if ( this.months[index] == this.month ) {
                this.currentMonth = index;
            }
        }
        this.generateDatesAndDays();

        // get timesheet and timesheet details from the month and year
        for ( let index = 0; index < 31; index++ ) {
            this.timesheetDetails.push( { date: this.dates[index], calendarCode: "", workStatus: "", ph: false, phLeave: false, shiftCode: "",
                normalStartTime: "", normalEndTime: "", leaveTaken: 0, oilCredit: 0, importedHours: 0, approvedHours: 0,
                importedHoursMonSat: 0, importedHoursSunPH: 0, approvedHoursMonSat: 0, approvedHoursSunPH: 0, ot15: 0, ot20: 0,
                overtimeStartTime: "", overtimeEndTime: "", standby: "", shiftStartTime: "", shiftEndTime: "",
                Shift12HourDay: 0, Shift12HourNight: 0, Shift8HourDay: 0, Shift8HourNight: 0, 
                clockIn: "", clockOut: "", clockHours: "",
                swingShiftDayAllowance: 0, swingShiftNightAllowance: 0, swingShiftSaturdayAllowance: 0, swingShiftSundayAllowance: 0,
                fab: "", machine: "", serviceOrder: "", purpose: "" } );
        }

        for ( let index in this.employees ) {
            if ( this.employees[index].id == this.userId ) {
                this.department = this.employees[index].department;
            }
        }

        this.status = config.TIMESHEET_STATUS_BLANK;
        if ( this.userId != "" && this.month != "" && this.year != "" ) {
            let param = {
                Token: this.token,
                UserID: this.userId,
                Month: this.month,
                Year: this.year
            };

            this.$store.state.isLoading = true;

            API.getTimesheet(param)
            .then((response) => {
                this.$store.state.isLoading = false;
                if (response.data.success) {
                    //this.categories = response.data.record;
                    // console.log(response.data);

                    if ( response.data.isEmpty ) {
                        this.isRejected = false;
                        this.status = config.TIMESHEET_STATUS_BLANK;

                        this.attachment1 = null;
                        this.attachment2 = null;
                        this.attachment3 = null;
                        this.attachment4 = null;
                        this.attachment5 = null;

                        this.attachmentFilename1 = '';
                        this.attachmentFilename2 = '';
                        this.attachmentFilename3 = '';
                        this.attachmentFilename4 = '';
                        this.attachmentFilename5 = '';

                        this.attachmentURL1 = '';
                        this.attachmentURL2 = '';
                        this.attachmentURL3 = '';
                        this.attachmentURL4 = '';
                        this.attachmentURL5 = '';

                        this.isNewLayout = response.data.isNewLayout;
                        this.newLayoutMessage = response.data.newLayoutMessage 
                                                ? response.data.newLayoutMessage.replace("\n","<br>")
                                                : this.defaultNewLayoutMessage;
                        if (this.isNewLayout){
                            for ( let index in response.data.record.TimesheetDetails ) {
                                let timesheetDetail = response.data.record.TimesheetDetails[index]; 
                                this.timesheetDetails[index].calendarCode = timesheetDetail.CalendarCode;
                                this.timesheetDetails[index].workStatus = timesheetDetail.WorkStatus;
                                this.timesheetDetails[index].ph = timesheetDetail.IsPublicHoliday;
                                this.timesheetDetails[index].phLeave = timesheetDetail.IsPublicHolidayLeave;
                                this.timesheetDetails[index].shiftCode = timesheetDetail.ShiftCode;
                                this.timesheetDetails[index].normalStartTime = timesheetDetail.NormalStartTime;
                                this.timesheetDetails[index].normalEndTime = timesheetDetail.NormalEndTime;
                                this.timesheetDetails[index].leaveTaken = timesheetDetail.LeaveTaken ? timesheetDetail.LeaveTaken : 0;
                                this.timesheetDetails[index].oilCredit = timesheetDetail.OilCredit ? timesheetDetail.OilCredit : 0;
                                this.timesheetDetails[index].ot15 = timesheetDetail.Ot15 ? timesheetDetail.Ot15 : 0;
                                this.timesheetDetails[index].ot20 = timesheetDetail.Ot20 ? timesheetDetail.Ot20 : 0;
                                this.timesheetDetails[index].Shift12HourDay = timesheetDetail.Shift12HourDay ? timesheetDetail.Shift12HourDay : 0;
                                this.timesheetDetails[index].Shift12HourNight = timesheetDetail.Shift12HourNight ? timesheetDetail.Shift12HourNight : 0;
                                this.timesheetDetails[index].Shift8HourDay = timesheetDetail.Shift8HourDay ? timesheetDetail.Shift8HourDay : 0;
                                this.timesheetDetails[index].Shift8HourNight = timesheetDetail.Shift8HourNight ? timesheetDetail.Shift8HourNight : 0;
                                this.timesheetDetails[index].swingShiftDayAllowance = timesheetDetail.SwingShiftDayAllowance ? timesheetDetail.SwingShiftDayAllowance : 0;
                                this.timesheetDetails[index].swingShiftNightAllowance = timesheetDetail.SwingShiftNightAllowance ? timesheetDetail.SwingShiftNightAllowance : 0;
                                this.timesheetDetails[index].swingShiftSaturdayAllowance = timesheetDetail.SwingShiftSaturdayAllowance ? timesheetDetail.SwingShiftSaturdayAllowance : 0;
                                this.timesheetDetails[index].swingShiftSundayAllowance = timesheetDetail.SwingShiftSundayAllowance ? timesheetDetail.SwingShiftSundayAllowance : 0;
                            }
                        }
                    }
                    else {
                        this.isNewLayout = response.data.isNewLayout;
                        this.newLayoutMessage = response.data.newLayoutMessage 
                                                ? response.data.newLayoutMessage.replace("\n","<br>")
                                                : this.defaultNewLayoutMessage;
                        var record = response.data.record;

                        this.timesheetID = response.data.record.Id;
                        this.status = response.data.record.Status;
                        this.remarks = response.data.record.Remarks;

                        if ( this.status == config.TIMESHEET_STATUS_APPROVED ) {
                            this.status += response.data.record.ApprovedText;
                            this.isApproved = true;
                        }
                        else if ( this.status == config.TIMESHEET_STATUS_REJECTED ) {
                            this.statusRejectedText = this.status + response.data.record.RejectedText;
                            this.isRejected = true;
                        }
                        else {
                            this.isApproved = false;
                            this.isRejected = false;
                        }

                        this.attachment1 = record.Attachment1;
                        this.attachment2 = record.Attachment2;
                        this.attachment3 = record.Attachment3;
                        this.attachment4 = record.Attachment4;
                        this.attachment5 = record.Attachment5;

                        this.attachmentFilename1 = record.AttachmentFilename1;
                        this.attachmentFilename2 = record.AttachmentFilename2;
                        this.attachmentFilename3 = record.AttachmentFilename3;
                        this.attachmentFilename4 = record.AttachmentFilename4;
                        this.attachmentFilename5 = record.AttachmentFilename5;

                        this.attachmentURL1 = record.AttachmentURL1;
                        this.attachmentURL2 = record.AttachmentURL2;
                        this.attachmentURL3 = record.AttachmentURL3;
                        this.attachmentURL4 = record.AttachmentURL4;
                        this.attachmentURL5 = record.AttachmentURL5;

                        //console.log(response.data.record.TimesheetDetails);

                        for ( let index in response.data.record.TimesheetDetails ) {
                            let timesheetDetail = response.data.record.TimesheetDetails[index];

                            this.timesheetDetails[index] = {
                                date: timesheetDetail.Date,
                                calendarCode: timesheetDetail.CalendarCode,
                                workStatus: timesheetDetail.WorkStatus,
                                ph: timesheetDetail.IsPublicHoliday,
                                phLeave: timesheetDetail.IsPublicHolidayLeave,
                                shiftCode: timesheetDetail.ShiftCode,
                                normalStartTime: timesheetDetail.NormalStartTime,
                                normalEndTime: timesheetDetail.NormalEndTime,
                                leaveTaken: timesheetDetail.LeaveTaken ? timesheetDetail.LeaveTaken : 0,
                                oilCredit: timesheetDetail.OilCredit ? timesheetDetail.OilCredit : 0,
                                importedHours: timesheetDetail.ImportedHours ? timesheetDetail.ImportedHours : 0,
                                approvedHours: timesheetDetail.WorkStatus == "Work" && !timesheetDetail.IsPublicHoliday
                                               ? (timesheetDetail.ShiftCode.includes("12") ? 0 : (timesheetDetail.ShiftCode.includes("8") && timesheetDetail.ApprovedHours && timesheetDetail.ApprovedHours > 4 ? 4: (timesheetDetail.ApprovedHours ? timesheetDetail.ApprovedHours : 0))) 
                                               : (timesheetDetail.ApprovedHours ? timesheetDetail.ApprovedHours : 0),
                                importedHoursMonSat: timesheetDetail.ImportedHoursMonSat ? timesheetDetail.ImportedHoursMonSat :0,
                                importedHoursSunPH: timesheetDetail.ImportedHoursSunPH ? timesheetDetail.ImportedHoursSunPH :0,
                                approvedHoursMonSat: timesheetDetail.ApprovedHoursMonSat ? timesheetDetail.ApprovedHoursMonSat : 0,
                                approvedHoursSunPH: timesheetDetail.ApprovedHoursSunPH ? timesheetDetail.ApprovedHoursSunPH : 0, 
                                ot15: timesheetDetail.Ot15 ? timesheetDetail.Ot15 : 0,
                                ot20: timesheetDetail.Ot20 ? timesheetDetail.Ot20 : 0,
                                overtimeStartTime: timesheetDetail.OvertimeStartTime ? timesheetDetail.OvertimeStartTime : 0, 
                                overtimeEndTime: timesheetDetail.OvertimeEndTime ? timesheetDetail.OvertimeEndTime : 0, 
                                standby: timesheetDetail.Standby, 
                                shiftStartTime: timesheetDetail.ShiftStartTime, 
                                shiftEndTime: timesheetDetail.ShiftEndTime,
                                Shift12HourDay: timesheetDetail.Shift12HourDay ? timesheetDetail.Shift12HourDay : 0, 
                                Shift12HourNight: timesheetDetail.Shift12HourNight ? timesheetDetail.Shift12HourNight : 0, 
                                Shift8HourDay: timesheetDetail.Shift8HourDay ? timesheetDetail.Shift8HourDay : 0, 
                                Shift8HourNight: timesheetDetail.Shift8HourNight ? timesheetDetail.Shift8HourNight : 0, 
                                clockIn: timesheetDetail.ClockIn ? timesheetDetail.ClockIn : 0,
                                clockOut: timesheetDetail.ClockOut ? timesheetDetail.ClockOut : 0,
                                clockHours: timesheetDetail.ClockHours ? timesheetDetail.ClockHours : 0,
                                swingShiftDayAllowance: timesheetDetail.SwingShiftDayAllowance ? timesheetDetail.SwingShiftDayAllowance : 0,
                                swingShiftNightAllowance: timesheetDetail.SwingShiftNightAllowance ? timesheetDetail.SwingShiftNightAllowance : 0,
                                swingShiftSaturdayAllowance: timesheetDetail.SwingShiftSaturdayAllowance ? timesheetDetail.SwingShiftSaturdayAllowance : 0,
                                swingShiftSundayAllowance: timesheetDetail.SwingShiftSundayAllowance ? timesheetDetail.SwingShiftSundayAllowance : 0,
                                fab: timesheetDetail.Fab ? timesheetDetail.Fab : "",
                                machine: timesheetDetail.Machine ? timesheetDetail.Machine : "", 
                                serviceOrder: timesheetDetail.ServiceOrder ? timesheetDetail.ServiceOrder : "", 
                                purpose: timesheetDetail.Purpose ? timesheetDetail.Purpose : ""
                            };
                        }
                    }
                } else {
                    this.$swal(response.data.Message, { icon: "error" });
                }

                if ( this.status == config.TIMESHEET_STATUS_BLANK || this.status == config.TIMESHEET_STATUS_DRAFT || this.status == config.TIMESHEET_STATUS_NEW || 
                        this.status == config.TIMESHEET_STATUS_REJECTED ) {
                    this.mode = "edit";
                    this.showSubmissionButton = true;
                    this.isApproved = false;

                    if ( !response.data.allowToSubmit && !response.data.allowToUpdate ) {
                        this.showSubmissionButton = false;
                    }
                }
                else {
                    this.mode = "view";
                    this.showSubmissionButton = false;
                }

                // console.log(this.status + " " + this.mode);

                this.calculateTotal();
            })
            .catch((error) => {
                this.$store.state.isLoading = false;
                this.$swal(error.response.data.Message, { icon: "error" });
            });   
        }

        if ( this.status == config.TIMESHEET_STATUS_BLANK || this.status == config.TIMESHEET_STATUS_DRAFT || this.status == config.TIMESHEET_STATUS_NEW || 
                this.status == config.TIMESHEET_STATUS_REJECTED ) {
            this.mode = "edit";
            this.showSubmissionButton = true;
        }
        else {
            this.mode = "view";
            this.showSubmissionButton = false;
        }

        //console.log(this.timesheetDetails);
    },
    changeMode(mode) {
        this.mode = mode;
    },
    getYears() {
        let date = new Date();
        let minYear = date.getFullYear() - 5;
        for ( let year = date.getFullYear(); year > minYear; year-- ) {
            this.years.push(year);
        }
    },
    getMonths() {
        this.months = [];
        this.month = "";
        
        this.months.push("Jan");
        this.months.push("Feb");
        this.months.push("Mar");
        this.months.push("Apr");
        this.months.push("May");
        this.months.push("Jun");
        this.months.push("Jul");
        this.months.push("Aug");
        this.months.push("Sep");
        this.months.push("Oct");
        this.months.push("Nov");
        this.months.push("Dec");
    },
    generateAvailableTimes() {
        this.availableTimes = [];
        let counter = 0;
        for ( let time = 15; time < 2346; ) {
            this.availableTimes.push(this.setTimeString(time));

            time += 15;
            counter++;

            if ( counter >= 3 ) {
                time += 40;
                counter = -1;
            }
        }

        this.availableTimes.push("0000");
    },
    setTimeString(time) {
        if ( time < 99 ) {
            time = "00" + time;
        }
        else if ( time < 999 ) {
            time = "0" + time;
        }

        return ""+time;
    },
    calculateTotal() {
        let totalLeaveTaken = 0;
        let totalOilCredit = 0;
        let totalImportedMonSat = 0;
        let totalImportedSunPH = 0;
        let totalImported = 0;
        let totalApprovedMonSat = 0;
        let totalApprovedSunPH = 0;
        let totalApproved = 0;
        let totalOT15 = 0;
        let totalOT20 = 0;
        let totalStandby12 = 0;
        let totalStandby24 = 0;
        let totalShift12Day = 0;
        let totalShift12Night = 0;
        let totalShift8Day = 0;
        let totalShift8Night = 0;
        let totalClockHours = 0;
        let totalSwingShiftDayAllowance = 0;
        let totalSwingShiftNightAllowance = 0;
        let totalSwingShiftSaturdayAllowance = 0;
        let totalSwingShiftSundayAllowance = 0;
        for ( let index = 0; index < this.timesheetDetails.length; index++ ) {
            totalLeaveTaken += this.parseNumber(this.timesheetDetails[index].leaveTaken);
            totalOilCredit += this.parseNumber(this.timesheetDetails[index].oilCredit);
            totalImportedMonSat += this.parseNumber(this.timesheetDetails[index].importedHoursMonSat);
            totalImportedSunPH += this.parseNumber(this.timesheetDetails[index].importedHoursSunPH);
            totalImported += this.parseNumber(this.timesheetDetails[index].importedHours);
            totalApprovedMonSat += this.parseNumber(this.timesheetDetails[index].approvedHoursMonSat);
            totalApprovedSunPH += this.parseNumber(this.timesheetDetails[index].approvedHoursSunPH);
            totalApproved += this.parseNumber(this.timesheetDetails[index].approvedHours);
            totalOT15 += this.parseNumber(this.timesheetDetails[index].ot15);
            totalOT20 += this.parseNumber(this.timesheetDetails[index].ot20);
            totalStandby12 += (this.timesheetDetails[index].standby == "1200") ? 1 : 0;
            totalStandby24 += (this.timesheetDetails[index].standby == "2400") ? 1 : 0;

            totalShift12Day += this.parseNumber(this.timesheetDetails[index].Shift12HourDay);
            totalShift12Night += this.parseNumber(this.timesheetDetails[index].Shift12HourNight);
            totalShift8Day += this.parseNumber(this.timesheetDetails[index].Shift8HourDay);
            totalShift8Night += this.parseNumber(this.timesheetDetails[index].Shift8HourNight);
            totalClockHours += this.parseNumber(this.timesheetDetails[index].clockHours ? this.timesheetDetails[index].clockHours : 0);

            totalSwingShiftDayAllowance += this.parseNumber(this.timesheetDetails[index].swingShiftDayAllowance);
            totalSwingShiftNightAllowance += this.parseNumber(this.timesheetDetails[index].swingShiftNightAllowance);
            totalSwingShiftSaturdayAllowance += this.parseNumber(this.timesheetDetails[index].swingShiftSaturdayAllowance);
            totalSwingShiftSundayAllowance += this.parseNumber(this.timesheetDetails[index].swingShiftSundayAllowance);
        }

        this.totalLeaveTaken = totalLeaveTaken;
        this.totalOilCredit = totalOilCredit;
        this.totalImportedMonSat = totalImportedMonSat;
        this.totalImportedSunPH = totalImportedSunPH;
        this.totalImported = totalImported;
        this.totalApprovedMonSat = totalApprovedMonSat;
        this.totalApprovedSunPH = totalApprovedSunPH;
        this.totalApproved = totalApproved;
        this.totalOT15 = totalOT15;
        this.totalOT20 = totalOT20;

        this.standby12 = totalStandby12;
        this.standby24 = totalStandby24;

        this.Shift12HourDay = totalShift12Day;
        this.Shift12HourNight = totalShift12Night;
        this.Shift8HourDay = totalShift8Day;
        this.Shift8HourNight = totalShift8Night;
        this.totalClockHours = totalClockHours;
        this.totalSwingShiftDayAllowance = totalSwingShiftDayAllowance;
        this.totalSwingShiftNightAllowance = totalSwingShiftNightAllowance;
        this.totalSwingShiftSaturdayAllowance = totalSwingShiftSaturdayAllowance;
        this.totalSwingShiftSundayAllowance = totalSwingShiftSundayAllowance;
    },
    parseNumber(number) {
        if ( number == "" || isNaN(number) ) {
            return 0;
        }
        return parseFloat(number);
    },
    checkOvertime(index) {
        let returnMessage = arguments[1] ? arguments[1] : false;
        
        if (this.isNewLayout) {
            let approvedHours = parseFloat(this.timesheetDetails[index].approvedHours);
            let workStatus = this.timesheetDetails[index].workStatus;
            let isPublicHoliday = this.timesheetDetails[index].ph;
            let shiftCodeWith8 = this.timesheetDetails[index].shiftCode.includes("8");
            if (workStatus == "Work" && !isPublicHoliday) {
                if (shiftCodeWith8 && approvedHours > this.maxHoursPerDayShift8) {
                    let message = "[" + this.displayDates[index] + "]: " + this.maxHoursPerDayShift8Message;
                    if (returnMessage) return message; else alert( message );
                }
            } else {
                if (approvedHours > this.maxHoursPerDay) {
                    let message = "[" + this.displayDates[index] + "]: " + this.maxHoursPerDayMessage;
                    if (returnMessage) return message; else alert( message );
                }
            }
        }

        if ( this.timesheetDetails[index].overtimeStartTime != "" && this.timesheetDetails[index].overtimeEndTime != "" && 
                this.timesheetDetails[index].overtimeStartTime != "0" && this.timesheetDetails[index].overtimeEndTime != "0" ) {
            let approvedHour = this.isNewLayout ? parseFloat(this.timesheetDetails[index].approvedHours) 
                               : (parseFloat(this.timesheetDetails[index].approvedHoursMonSat == 0 ? this.timesheetDetails[index].approvedHoursSunPH : this.timesheetDetails[index].approvedHoursMonSat));
            let overtimeStartTime = parseFloat(this.timesheetDetails[index].overtimeStartTime);
            let overtimeEndTime = parseFloat(this.timesheetDetails[index].overtimeEndTime);

            let overtimeStartTimeHour = parseInt(overtimeStartTime / 100);
            let overtimeStartTimeMin = parseInt(overtimeStartTime % 100);

            let overtimeEndTimeHour = parseInt(overtimeEndTime / 100);
            let overtimeEndTimeMin = parseInt(overtimeEndTime % 100);

            let approvedMin = parseFloat((approvedHour - Math.floor(approvedHour)) * 60);
            approvedHour = parseFloat(Math.floor(approvedHour));

            let overtimeTimeDiff = ((overtimeEndTimeHour * 60) + overtimeEndTimeMin) - ((overtimeStartTimeHour * 60) + overtimeStartTimeMin);
            let approvedTime = (approvedHour * 60) + approvedMin;
            if ( overtimeStartTime > overtimeEndTime ) {
                overtimeTimeDiff = (((overtimeEndTimeHour + 24) * 60) + overtimeEndTimeMin) - ((overtimeStartTimeHour * 60) + overtimeStartTimeMin);
            } 

            approvedHour = parseFloat(approvedHour);

            if ( overtimeTimeDiff != approvedTime ) {
                let message = "[" + this.displayDates[index] + "]: Overtime Start and End Date Time are not tallied with the approved OT Hours.";
                if ( returnMessage ) {
                    return message;
                }
                else {
                    alert( message );
                }
            }


            /*if ( returnMessage && ( overtimeStartTime == "0" || overtimeStartTime == "" || overtimeEndTime == "0" || overtimeEndTime == "" ) ) {
                return "[" + this.displayDates[index] + "]: Please set both Overtime Start and End Date Time.";
            }*/
        }
        else if ( returnMessage && ( (!this.isNewLayout && this.timesheetDetails[index].approvedHoursMonSat != "0" && this.timesheetDetails[index].approvedHoursMonSat != "" ) || 
            (!this.isNewLayout && this.timesheetDetails[index].approvedHoursSunPH != "0" && this.timesheetDetails[index].approvedHoursSunPH != "") 
            || (this.isNewLayout && this.timesheetDetails[index].approvedHours != "0" && this.timesheetDetails[index].approvedHours != "") ) ) {
            return "[" + this.displayDates[index] + "]: Please set both Overtime Start and End Date Time.";
        }
        else if ( returnMessage && ((!this.isNewLayout && (this.timesheetDetails[index].approvedHoursMonSat === "" || this.timesheetDetails[index].approvedHoursSunPH === "")) 
            || (this.isNewLayout && this.timesheetDetails[index].approvedHours === "") ) ) {
            return "[" + this.displayDates[index] + "]: Please ensure Approved OT Hours column has values. Blank fields are not allowed.";
        }       
    },
    checkShiftTime(index) {
        let returnMessage = arguments[1] ? arguments[1] : false;
        this.timesheetDetails[index].Shift8HourDay = 0;
        this.timesheetDetails[index].Shift8HourNight = 0;
        this.timesheetDetails[index].Shift12HourDay = 0;
        this.timesheetDetails[index].Shift12HourNight = 0;
        
        // console.log("Check shift time");
        // console.log(this.timesheetDetails[index].shiftStartTime + " " + this.timesheetDetails[index].shiftEndTime);
        // console.log(this.timesheetDetails[index].Shift8HourDay + " " + this.timesheetDetails[index].Shift8HourNight);
        // console.log(this.timesheetDetails[index].Shift12HourDay + " " +  this.timesheetDetails[index].Shift12HourNight);

        if ( this.timesheetDetails[index].shiftStartTime != "" && this.timesheetDetails[index].shiftEndTime != "" ) {
            let shiftStartTime = parseInt(this.timesheetDetails[index].shiftStartTime);
            let shiftEndTime = parseInt(this.timesheetDetails[index].shiftEndTime);
            let timeDiff = shiftEndTime - shiftStartTime;

            if ( shiftEndTime < shiftStartTime ) {
                timeDiff = shiftEndTime + 2400 - shiftStartTime;
            }

            let message = "";
            if ( timeDiff == 800 || timeDiff == 1200 ) {
                if ( timeDiff == 800 ) {
                    if ( shiftStartTime > 600 && shiftStartTime < 1200 ) {
                        message = ( "[" + this.displayDates[index] + "]: Shift Start and Date Time for 8 Hours shift is not valid." );
                    }
                    else {
                        if ( shiftStartTime >= 1200 && shiftStartTime < 2100 ) {
                            this.timesheetDetails[index].Shift8HourDay = 1;
                        }
                        else {
                            this.timesheetDetails[index].Shift8HourNight = 1;
                        }
                    }
                }
                else {
                     if ( shiftStartTime >= 600  && shiftStartTime < 1800 ) {
                        this.timesheetDetails[index].Shift12HourDay = 1;
                    }
                    else {
                        this.timesheetDetails[index].Shift12HourNight = 1;
                    }
                }
            }
            else {
                message = ( "[" + this.displayDates[index] + "]: Shift Start and Date Time must be exactly 12 Hours or 8 Hours." );
            }

            
            if ( returnMessage ) {
                return message;
            }
            else if ( message != "" ) {
                alert( message );
            }
        }
        else if ( returnMessage && ( this.timesheetDetails[index].shiftStartTime != "" || this.timesheetDetails[index].shiftEndTime != "" ) ) {
            return "[" + this.displayDates[index] + "]: Please set both Shift Start and End Date Time.";
        }

        this.calculateTotal();
    },
    checkClockHours(index){
        let returnMessage = arguments[1] ? arguments[1] : false;
        this.timesheetDetails[index].clockHours = null;

        if (this.timesheetDetails[index].clockIn != "" && this.timesheetDetails[index].clockIn != 0 
                && (this.timesheetDetails[index].clockOut == "" || this.timesheetDetails[index].clockOut == 0)) {
            let message = "[" + this.displayDates[index] + "]: Please set Clock Out time.";
            if (returnMessage) return message;
        } else if (this.timesheetDetails[index].clockOut != "" && this.timesheetDetails[index].clockOut != 0 
                    && (this.timesheetDetails[index].clockIn == "" || this.timesheetDetails[index].clockIn == 0)){
            let message = "[" + this.displayDates[index] + "]: Please set Clock In time.";
            if (returnMessage) return message;
        }

        if (this.timesheetDetails[index].clockIn != "" && this.timesheetDetails[index].clockOut != ""
            && this.timesheetDetails[index].clockIn != "0" && this.timesheetDetails[index].clockOut != "0") {
            let clockIn = parseFloat(this.timesheetDetails[index].clockIn);
            let clockOut = parseFloat(this.timesheetDetails[index].clockOut);
            let clockInHour = parseInt(clockIn / 100);
            let clockInMin = parseInt(clockIn % 100);
            let clockOutHour = parseInt(clockOut / 100);
            let clockOutMin = parseInt(clockOut % 100);
            let clockTimeDiff = ((clockOutHour * 60) + clockOutMin) - ((clockInHour * 60) + clockInMin);
            // if (clockIn > clockOut) {
            //     let message = "[" + this.displayDates[index] + "]: Clock Out time cannot be earlier than Clock In time.";
            //     if (returnMessage) return message; else alert(message);
            // } else {
            //     this.timesheetDetails[index].clockHours = parseFloat(clockTimeDiff / 60);
            // }
            if (clockIn > clockOut) {
                clockTimeDiff = (((clockOutHour + 24) * 60) + clockOutMin) - ((clockInHour * 60) + clockInMin);
            }
            this.timesheetDetails[index].clockHours = parseFloat(clockTimeDiff / 60);
        }
        this.calculateTotal();
    },
    calculateSwingShiftAllowance(index){
        let clockHours = 0;
        if (this.timesheetDetails[index].clockIn != "" && this.timesheetDetails[index].clockOut != ""
            && this.timesheetDetails[index].clockIn != "0" && this.timesheetDetails[index].clockOut != "0") {
            let clockIn = parseFloat(this.timesheetDetails[index].clockIn);
            let clockOut = parseFloat(this.timesheetDetails[index].clockOut);
            let clockInHour = parseInt(clockIn / 100);
            let clockInMin = parseInt(clockIn % 100);
            let clockOutHour = parseInt(clockOut / 100);
            let clockOutMin = parseInt(clockOut % 100);
            let clockTimeDiff = ((clockOutHour * 60) + clockOutMin) - ((clockInHour * 60) + clockInMin);
            if (clockIn <= clockOut) {
                clockHours = parseFloat(clockTimeDiff / 60);
            }
        }
        let param = {
            Token: this.token,
            UserID: this.userId,
            Date: this.timesheetDetails[index].date,
            ApprovedHours: this.timesheetDetails[index].approvedHours,
            ClockHours: clockHours
        };
        API.calculateSwingShiftAllowance(param)
            .then((response) => {
                if (response.data.success) {
                    this.timesheetDetails[index].swingShiftDayAllowance = response.data.ssDayAllowance;
                    this.timesheetDetails[index].swingShiftNightAllowance = response.data.ssNightAllowance;
                    this.timesheetDetails[index].swingShiftSaturdayAllowance = response.data.ssSaturdayAllowance;
                    this.timesheetDetails[index].swingShiftSundayAllowance = response.data.ssSundayAllowance;
                    this.calculateTotal();
                } else {
                    console.log(response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    },
    validate() {
        if (!this.userId){
            alert("Please select an employee");
            return false;
        }
        let messages = [];
        for ( let index in this.timesheetDetails ) {
            let message = this.checkOvertime(index, true);
            let message1 = !this.isNewLayout ? this.checkShiftTime(index, true) : "";
            let message2 = this.checkClockHours(index, true);

            if ( message && message != "" ) {
                messages.push(message);
            }

            if ( message1 && message1 != "" ) {
                messages.push(message1);
            }

            if ( message2 && message2 != "" ) {
                messages.push(message2);
            }
        }

        if ( messages.length > 0 ) {
            alert( messages.join("\n") );

            return false;
        }

        return true;
    },
    save() {
        if ( !this.validate() ) {
            return;
        }

      let param = {
        Token: this.token,
        UserId: this.userId,
        Month: this.month,
        Year: this.year,
        TimesheetDetails: this.timesheetDetails,
        Attachment1: this.newAttachment1,
        Attachment2: this.newAttachment2,
        Attachment3: this.newAttachment3,
        Attachment4: this.newAttachment4,
        Attachment5: this.newAttachment5,
        AttachmentFilename1: this.newAttachmentFilename1,
        AttachmentFilename2: this.newAttachmentFilename2,
        AttachmentFilename3: this.newAttachmentFilename3,
        AttachmentFilename4: this.newAttachmentFilename4,
        AttachmentFilename5: this.newAttachmentFilename5,
        DeletedAttachment: this.deletedAttachment.length > 0 ? this.deletedAttachment.join(",") : "",
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to save the timesheet?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.saveTimesheet(param)
            .then((response) => {
                this.$store.state.isLoading = false;
                this.$swal(response.data.Message, {
                    icon: response.data.success ? "success" : "error",
                });

                this.getTimesheet();

                //console.log(this.timesheetDetails);
            })
            .catch((error) => {
                //console.log(error);
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    submit() {
        if ( this.role != 'admin' && !this.tokenObj.HasManager ) {
            alert("No manager assigned.");
            return;
        }

        if ( !this.validate() ) {
            return;
        }

        if ( (!this.isNewLayout && (this.totalApprovedMonSat + this.totalApprovedSunPH) > this.maxHours ) 
            || ( this.isNewLayout && this.totalApproved > this.maxHours ) ) {
            alert(this.maxHoursMessage);
            return;
        }

      let param = {
        Token: this.token,
        UserId: this.userId,
        Month: this.month,
        Year: this.year,
        TimesheetDetails: this.timesheetDetails,
        Attachment1: this.newAttachment1,
        Attachment2: this.newAttachment2,
        Attachment3: this.newAttachment3,
        Attachment4: this.newAttachment4,
        Attachment5: this.newAttachment5,
        AttachmentFilename1: this.newAttachmentFilename1,
        AttachmentFilename2: this.newAttachmentFilename2,
        AttachmentFilename3: this.newAttachmentFilename3,
        AttachmentFilename4: this.newAttachmentFilename4,
        AttachmentFilename5: this.newAttachmentFilename5,
        DeletedAttachment: this.deletedAttachment.length > 0 ? this.deletedAttachment.join(",") : "",
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to submit the timesheet?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.submitTimesheet(param)
            .then((response) => {
                this.$store.state.isLoading = false;
                this.$swal(response.data.Message, {
                    icon: response.data.success ? "success" : "error",
                });

                this.getTimesheet();

                //console.log(this.timesheetDetails);
            })
            .catch((error) => {
                //console.log(error);
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    saveChanges() {
        if ( !this.validate() ) {
            return;
        }

        if ( (!this.isNewLayout && (this.totalApprovedMonSat + this.totalApprovedSunPH) > this.maxHours ) 
            || ( this.isNewLayout && this.totalApproved > this.maxHours ) ) {
            alert(this.maxHoursMessage);
            return;
        }

        if ( !this.remarks || (this.remarks && this.remarks.trim() == "") ) {
            alert("Please indicate the reason for the changes.");
            return;
        }

        let param = {
            Token: this.token,
            Id: this.timesheetID,
            UserId: this.userId,
            Month: this.month,
            Year: this.year,
            TimesheetDetails: this.timesheetDetails,
            Remarks: this.remarks
        };
        this.$swal({
            title: "Are you sure?",
            text: "Are you sure you want to save? An email notification will be sent to employee.\nClick OK to save the changes.",
            icon: "info",
            buttons: true,
            dangerMode: false,
        }).then((willSave) => {
            if (willSave) {
                this.$store.state.isLoading = true;
                API.saveChangesTimesheet(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    this.$swal(response.data.Message, {
                        icon: response.data.success ? "success" : "error",
                    });

                    this.loadTimesheet(this.timesheetID);
                    this.changeMode('view');

                    //console.log(this.timesheetDetails);
                })
                .catch((error) => {
                    //console.log(error);
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
            }
        });
    },
    approve() {
        /*if ( !this.remarks || (this.remarks && this.remarks.trim() == "") ) {
            alert("Please fill in the remarks.");
            return;
        }*/

        if ( ( !this.isNewLayout && (this.totalApprovedMonSat + this.totalApprovedSunPH) > this.maxHours )
             || ( this.isNewLayout && this.totalApproved > this.maxHours ) ) {
            alert(this.maxHoursMessage);
            return;
        }

        let param = {
            Token: this.token,
            Id: this.timesheetID,
            UserId: this.userId,
            Month: this.month,
            Year: this.year,
            TimesheetDetails: this.timesheetDetails,
            Remarks: this.remarks
        };
        this.$swal({
            title: "Are you sure?",
            text: "You are going to approve this timesheet. Click OK to continue.",
            icon: "info",
            buttons: true,
            dangerMode: false,
        }).then((willSave) => {
            if (willSave) {
                this.$store.state.isLoading = true;
                API.approveTimesheet(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    this.$swal(response.data.Message, {
                        icon: response.data.success ? "success" : "error",
                    });

                    this.loadTimesheet(this.timesheetID);
                    this.changeMode('view');

                    //console.log(this.timesheetDetails);
                })
                .catch((error) => {
                    //console.log(error);
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
            }
        });
    },
    reject() {
        if ( !this.remarks || (this.remarks && this.remarks.trim() == "") ) {
            alert("Please specify the reason why you are rejecting the timesheet.");
            return;
        }

        let param = {
            Token: this.token,
            Id: this.timesheetID,
            UserId: this.userId,
            Month: this.month,
            Year: this.year,
            TimesheetDetails: this.timesheetDetails,
            Remarks: this.remarks
        };
        this.$swal({
            title: "Are you sure?",
            text: "You are going to reject this timesheet. Click OK to continue.",
            icon: "info",
            buttons: true,
            dangerMode: false,
        }).then((willSave) => {
            if (willSave) {
                this.$store.state.isLoading = true;
                API.rejectTimesheet(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    this.$swal(response.data.Message, {
                        icon: response.data.success ? "success" : "error",
                    });

                    this.loadTimesheet(this.timesheetID);
                    this.changeMode('view');

                    //console.log(this.timesheetDetails);
                })
                .catch((error) => {
                    //console.log(error);
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
            }
        });
    },
    changeToDraft() {
        let param = {
            Token: this.token,
            Id: this.timesheetID
        };

        this.$swal({
            title: "Are you sure?",
            text: "Are you sure you want to change the status to draft?",
            icon: "info",
            buttons: true,
            dangerMode: false,
        }).then((willSave) => {
            if (willSave) {
                this.$store.state.isLoading = true;
                API.changeToDraftTimesheet(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    this.$swal(response.data.Message, {
                        icon: response.data.success ? "success" : "error",
                    });

                    if ( this.isLoadData ) {
                        this.loadTimesheet(this.timesheetID);
                    }
                    else {
                        this.getTimesheet();
                    }

                    //console.log(this.timesheetDetails);
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
            }
        });
    },
    checkNewLayout(month, year) {
        let param = {
            Token: this.token,
            Month: month,
            Year: year
        };
        API.checkNewLayout(param)
        .then((response) => {
            if (response.data.success) {
                this.isNewLayout = response.data.isNewLayout;
                this.newLayoutMessage = response.data.newLayoutMessage 
                    ? response.data.newLayoutMessage.replace("\n","<br>")
                    : this.defaultNewLayoutMessage;
            }
            else {
                this.$swal(response.data.Message, { icon: "error" });
            }
        })
        .catch((error) => {
            this.$store.state.isLoading = false;
            this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    adjustTable(){
        let height = $(".scroll-area").outerHeight() - $("header").outerHeight() - $(".page-header").outerHeight() - 100;
        $("div.table-responsive").css('maxHeight', height + "px");

        var firstRowHeight = 0;
        $("#t-first-row th").each(function() {
            if ( $(this).outerHeight() > firstRowHeight ) {
                firstRowHeight = $(this).outerHeight();
            }
        });

        $("#t-second-row th").each(function() {
            $(this).css('top', (firstRowHeight) + "px");
        });

        $(".table-timesheet #t-first-row th, .table-timesheet #t-second-row th").each(function() {
            $(this).css('font-size', '12px');
        });

        $(".table-timesheet tbody td select").each(function() {
            $(this).css('font-size', '14px').css('min-width', '80px');
        });

        $(".table-timesheet tbody td input").each(function() {
            $(this).css('font-size', '13px');
            if ( !$(this).hasClass('text-fab') && !$(this).hasClass('text-machine') && !$(this).hasClass('text-service-order') ) {
                $(this).css('min-width', '51px');
            }
        });
    }
  },

  mounted() {
    window.setTimeout(() => {
        this.adjustTable();
    }, 500);
  },

  created() {
    this.getYears();
    this.getMonths();

    let date = new Date();
    this.month = this.months[date.getMonth()];
    this.currentMonth = date.getMonth();
    this.year = date.getFullYear();

    this.checkNewLayout(this.month, this.year);
    this.generateAvailableTimes();
    
    if ( this.$route.params.id && this.$route.params.id != "" ) {
        this.loadTimesheet(this.$route.params.id);
    }
    else {
        this.getEmployees();
        this.getTimesheet();
    }

    this.maxHoursMessage = 'Maximum Total Allowed Approved OT Hours for submission is ' + this.maxHours + '.';
  },
};
</script>

<style scoped>
.table-responsive {
  max-height: 584px;
}

.custom-table {
  padding: 0;
  border: 1px solid #dee2e6;
}

.custom-table tr {
  -webkit-box-shadow: none;
  box-shadow: none;
}

thead th {
  top: 0;
  position: sticky;
  position: -webkit-sticky;
  z-index: 20;
}

thead tr:nth-child(2) th {
    top: 90px;
}

/* td {
  z-index: 10;
} */

th,
td {
  padding: 0;
  outline: 1px solid #dee2e6;
  border: none;
  outline-offset: 0;
}

.col-group {
  left: 0;
  position: sticky;
  position: -webkit-sticky;
  background-color: #fff;
}

tr td.col-group:nth-child(2),
tr th.col-group:nth-child(2) {
    left: 85px;
}
tr td.col-group:nth-child(3),
tr th.col-group:nth-child(3) {
    left: 155px;
} 
tr td.col-group:nth-child(4),
tr th.col-group:nth-child(4) {
    left: 284.5px;
}
tr td.col-group:nth-child(5),
tr th.col-group:nth-child(5) {
    left: 363px;
}
tr td.col-group:nth-child(6),
tr th.col-group:nth-child(6) {
    left: 449px;
}
tr td.col-group:nth-child(7),
tr th.col-group:nth-child(7) {
    left: 554.5px;
}
tr td.col-group:nth-child(8),
tr th.col-group:nth-child(8) {
    left: 659.5px;
}
tr td.col-group:nth-child(9),
tr th.col-group:nth-child(9) {
    left: 734.5px;
}

#t-second-row th {
    top: 89px;
}

tr th.col-group {
    z-index: 51 !important;
}

.col-benefitoption {
  left: 86px;
  position: sticky;
  position: -webkit-sticky;
  background-color: #fff;
}
.fixed-column {
  z-index: 50;
}
.col-attendance-center {
    text-align: center;
    white-space: normal;
    vertical-align: middle;
}
.table-timesheet th,
.table-timesheet td {
    /*font-size: 0.75rem;*/
    font-size: 12px;
}
.table-timesheet td .custom-select {
    font-size: 14px;
}
.table-inner-detail td.view {
    border: none;
    padding: 8px 15px;
}
.table-inner-detail td.readonly {
    background-color: #e9ecef;
    border: none;
    padding: 8px 15px;
}
.table-inner-detail td.edit,
.table-timesheet td.edit {
    border: none;
    padding: 4px 5px !important;
}
.table-timesheet td input[type="text"].form-control {
    height: 25px;
    font-size: 13px;
    padding-left: 8px;
    padding-right: 8px;
}
.custom-select.attendance {
    padding-top: 2px;
    padding-bottom: 2px;
    padding-left: 8px;
    height: 26px;
}
.custom-select.standbyedit {
    width: 80px;
}
.text-fab, .text-machine, .text-service-order, .text-purpose {
    width: 100px;
}
.text-purpose {
    width: 300px;
}
.table.custom-table > tbody > tr > td, .table.custom-table > tfoot > tr > td, .table.custom-table > thead > tr > td {
    padding: 4px 10px !important;
}
textarea {
    resize: none;
}
.timesheethighlighted {
    background-color: yellow;
}
.table-shift {
    background-color: #dee2e6 !important;
}
th.table-shift, td.table-shift {
    outline: 1px solid #EFEFEF;
    outline-offset: 0;
}
.fa.fa-minus-circle {
    cursor: pointer;
}
.table-inner.shifteditnew {
    width: 370px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Attendance/Timesheet.vue